import React, { useState, useEffect, useCallback } from 'react'
import { CircularProgress } from '@mui/material'
import { useSelector } from 'react-redux'

import { get } from 'services/api'

import classNames from 'classnames'
import { makeStyles } from '@mui/styles'
import Container, { LoadingContainer, styles } from './styles'
import ComplementaryReviewInfo from './ComplementaryReviewInfo'
import ReviewsList from './ReviewsList'

export default function ManualAnalysisList(props) {
  const { applicationId } = props
  const token = useSelector((state) => state.auth.access_token)
  const [reviewsList, setReviewsList] = useState([])
  const [review, setReview] = useState({
    background_check: null,
    reference_check: null,
  })
  const [loading, setLoading] = useState(false)


  const load = useCallback(async () => {
    setLoading(true)
    const res = await get({
      url: `/reviews/paginated?application_uuid=${applicationId}`,
      token: token,
    })
      .then((response) => response)
      .catch((error) => console.error(error))
    if (res) {
      setReviewsList(res.items)
      setReview(res.items?.[0] || {})
    }
    setLoading(false)
  }, [setReviewsList, applicationId, token])

  useEffect(() => {
    load()
  }, [load])
  
  const classes = makeStyles(() => (styles))()
  return (
    <Container>
      {loading ? (
        <LoadingContainer>
          <span>
            <CircularProgress size={70} />
          </span>
          <span>Buscando informações para revisão...</span>
        </LoadingContainer>
      ) : (
        <div className={classNames(classes.gappedItem, classes.largeGap)}>
          
          <ComplementaryReviewInfo review={review}/>
          
          <ReviewsList reviews={reviewsList} splitReviewsByArea={true} />
        
        </div>
      )}
    </Container>
  )
}
